import React, {useState, useEffect} from 'react';
import {
    AuthPaneContainer,
    Button,
    ButtonTypes,
    customToast,
    FormInput,
    Title,
    Variants
} from "toolbox-react-frontend-components";
import {useNavigate} from "react-router-dom";
import {cloneDeep} from "lodash";
import axios from "axios";
import {setAuthToken} from "../../helpers/AuthTokenHelper";
import {route} from "ziggy-js";
import Turnstile, { useTurnstile } from "react-turnstile";

const LoginPage = () => {
    const navigate  = useNavigate();
    const turnstile = useTurnstile();

    const [data, setData] = useState({
        email:              '',
        password:           '',
        cloudflare_token:   '',
    });
    const [errors, setErrors]           = useState(null);
    const [submitting, setSubmitting]   = useState(false);

    useEffect(() => {
        if (submitting) {
            submit();
        }
    }, [submitting]);

    const submit = () => {
        setErrors(null);

        axios.post(route('api.admin.login.process').toString(), data)
            .then((response) => {
                setAuthToken(response.data.token);

                window.location.href = route('admin.dashboard');
            })
            .catch((error) => {
                if (!!error && !!error.response && !!error.response.data) {
                    if (!!error.response.data.message) {
                        customToast({
                            title:      error.response.data.message,
                            variant:    Variants.Danger
                        });
                    }

                    if (!!error.response.data.errors) {
                        setErrors(error.response.data.errors);
                    }

                    turnstile.reset();

                    setSubmitting(false);
                } else {
                    console.log(error);
                    customToast({
                        title:      'An error occurred. Please refresh the page to try again.',
                        variant:    Variants.Danger
                    });
                }
            });
    }

    const updateField = (field, value) => {
        let clone = cloneDeep(data);

        switch (field) {
            default:
                clone[field] = value;
                break;
        }

        setData(clone);
    }

    return (
        <AuthPaneContainer
            fillerImage={'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/SSL_SL9000J_%2872ch%29_%40_The_Cutting_Room_Recording_Studios%2C_NYC.jpg/2560px-SSL_SL9000J_%2872ch%29_%40_The_Cutting_Room_Recording_Studios%2C_NYC.jpg'}
        >
            <Title
                title={'Login'}
            />
            <FormInput
                type={'email'}
                label={'Email'}
                name={'email'}
                value={data.email}
                errorMessages={!!errors && !!errors.email ? errors.email : null}
                onChange={(value) => updateField('email', value)}
                disabled={submitting}
            />
            <FormInput
                type={'password'}
                label={'Password'}
                name={'password'}
                value={data.password}
                errorMessages={!!errors && !!errors.password ? errors.password : null}
                onChange={(value) => updateField('password', value)}
                disabled={submitting}
            />
            <div className={'d-flex justify-content-center align-items-center'}>
                <Turnstile
                    sitekey={CLOUDFLARE.site_key}
                    onVerify={(token) => updateField('cloudflare_token', token)}
                    theme={'light'}
                />
            </div>
            <Button
                label={submitting ? 'Logging in...' : 'Login'}
                onClick={(event) => setSubmitting(true)}
                className={'w-100 justify-content-center mb-3 mt-5'}
                disabled={submitting}
            />
            <div className={'d-flex justify-content-center align-items-center'}>
                <Button
                    label={'Forgotten password'}
                    onClick={() => navigate(route('admin.password.request', undefined, false))}
                    type={ButtonTypes.Link}
                    variant={Variants.Dark}
                    disabled={submitting}
                />
            </div>
        </AuthPaneContainer>
    );
}

export default LoginPage;
